// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component } from 'react';
import {
  canPlay,
  MATCH_URL_TWITCH_CHANNEL,
  MATCH_URL_TWITCH_VIDEO
} from '../../../constants';
import { defaultProps } from '../props';
import type { BaseReactPlayerProps } from '../types';
import { callPlayer, getSDK, randomString } from '../utils';

const SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
const SDK_GLOBAL = 'Twitch';
const PLAYER_ID_PREFIX = 'twitch-player-';

export class Twitch extends Component<BaseReactPlayerProps> {
  static defaultProps = defaultProps;

  static canPlay = canPlay.twitch;

  static loopOnEnded = true;

  callPlayer = callPlayer;

  playerID =
    this.props.config.twitch.playerId || `${PLAYER_ID_PREFIX}${randomString()}`;

  load(url, isReady) {
    const isChannel = MATCH_URL_TWITCH_CHANNEL.test(url);
    const id = isChannel
      ? url.match(MATCH_URL_TWITCH_CHANNEL)[1]
      : url.match(MATCH_URL_TWITCH_VIDEO)[1];

    if (isReady && this.player) {
      if (isChannel) {
        this.player.setChannel(id);
      } else {
        this.player.setVideo(`v${id}`);
      }
      return;
    }

    getSDK(SDK_URL, SDK_GLOBAL).then((Twitch) => {
      const {
        onLoaded,
        onReady,
        onPlay,
        onPause,
        onEnded,
        onSeek,
        playing,
        muted,
        playsinline,
        controls,
        config
      } = this.props;

      this.player = new Twitch.Player(this.playerID, {
        video: isChannel ? '' : id,
        channel: isChannel ? id : '',
        height: '100%',
        width: '100%',
        playsinline,
        autoplay: playing,
        muted,
        // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
        controls: isChannel ? true : controls,
        ...config.twitch.options
      });

      const { READY, PLAYING, PAUSE, ENDED, ONLINE, OFFLINE, SEEK } =
        Twitch.Player;

      this.player.addEventListener(READY, onReady);
      this.player.addEventListener(PLAYING, onPlay);
      this.player.addEventListener(PAUSE, onPause);
      this.player.addEventListener(ENDED, onEnded);
      this.player.addEventListener(SEEK, onSeek);

      // Prevent weird isLoading behaviour when streams are offline
      this.player.addEventListener(ONLINE, onLoaded);
      this.player.addEventListener(OFFLINE, onLoaded);
    }, this.props.onError);
  }

  play() {
    this.callPlayer('play');
  }

  pause() {
    this.callPlayer('pause');
  }

  stop() {
    this.callPlayer('pause');
  }

  seekTo(seconds) {
    this.callPlayer('seek', seconds);
  }

  setVolume(fraction) {
    this.callPlayer('setVolume', fraction);
  }

  mute = () => {
    this.callPlayer('setMuted', true);
  };

  unmute = () => {
    this.callPlayer('setMuted', false);
  };

  getDuration() {
    return this.callPlayer('getDuration');
  }

  getCurrentTime() {
    return this.callPlayer('getCurrentTime');
  }

  getSecondsLoaded() {
    return null;
  }

  render() {
    const style = {
      width: '100%',
      height: '100%'
    };

    return <div style={style} id={this.playerID} />;
  }
}
